import { render, staticRenderFns } from "./CustomerWsuAddNew.vue?vue&type=template&id=5d314b8f&scoped=true&"
import script from "./CustomerWsuAddNew.vue?vue&type=script&lang=js&"
export * from "./CustomerWsuAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d314b8f",
  null
  
)

export default component.exports